import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import CustomFieldsComponent from "./customFields/index";
import { UseCustomFields } from "./customFields/useCustomFields";
import DefaultFieldsComponent from "./defaultFields/index";
import { UseDefaultFields } from "./defaultFields/useDefaultFields";
import RevisionsFieldsComponent from "./RevisionFilters/index";
import { useRevisionFields } from "./RevisionFilters/useRevisionFields";
import DistributionFieldsComponent from "./DistributionFilters/index";
import { UseDistributionFields } from "./DistributionFilters/useDistributionFields";
import { ReactComponent as CrossIcon } from "../../../../assets/crossIcon.svg";
import { ReactComponent as BatchUpdateIcon } from "../../../../assets/patch-update.svg";
import { useSelector } from "react-redux";
import moment from "moment";
import { shouldAllow } from "../../utils";

const BatchUpdateSection = ({
  handleFilter,
  handleClose,
  selectedTemplate,
  setSelectedTemplate,
  filterDataFetched,
  dynamicFieldsOptions,
  setDynamicFieldsOptions,
}) => {
  const [custom, setCustom, createCustom, deleteCustom, updateCustom] =
    UseCustomFields();

  const [defaults, setDefault, createDefault, deleteDefault, updateDefault] =
    UseDefaultFields();

  const [rev, setRev, createRev, deleteRev, updateRev] = useRevisionFields();

  const [dist, setDist, createDist, deleteDist, updateDist] =
    UseDistributionFields();

  const { isCollapsed } = useSelector((state) => state.authReducer);
  const { allDocStatuses } = useSelector((state) => state.docStatusReducer);

  const [defaultFieldsOptions, setDefaultFieldsOptions] = useState([]);

  // Using a fixed list of document fields instead of fetching from reducer
  const fixedDocumentFields = [
    { name: "Document Date", id: 1 },
    { name: "Status", id: 2 },
    { name: "Due Date", id: 3 },
    { name: "Sheets", id: 4 },
    { name: "Comments", id: 5 }
  ];


  useEffect(() => {
    let indexes = [0, 3, 4, 7, 8];
    let datesIndexes = [0, 4]; // 0, 4 ==>  dates
    let statusIndex = [3]; // 3 =>  status
    let sheetAndCommentIndexes = [7, 8]; // 7, 8 ==> sheet and comments
    let statusOptions = allDocStatuses.map((el) => {
      return {
        id: el.id,
        name: el.status_name,
        template_field_id: 192,
        is_deleted: false,
      };
    });

    if (fixedDocumentFields.length > 0) {
      // Date,  Status , Due Date,  Sheet,  Comments
      let filtered = fixedDocumentFields
        .map((field, i) => {
          if (indexes.includes(i)) {
            const { name, id } = field;
            if (datesIndexes.includes(i)) {
              return {
                id: name,
                name,
                fieldIndex: i,
                field_type: "date_field",
                is_deleted: false,
                field_options: [],
              };
            } else if (statusIndex.includes(i)) {
              return {
                id: name,
                name,
                field_type: "select_field",
                fieldIndex: i,
                is_deleted: false,
                field_options: statusOptions,
              };
            } else if (sheetAndCommentIndexes.includes(i)) {
              return {
                id: name,
                name,
                field_type: "text_field",
                fieldIndex: i,
                is_deleted: false,
                field_options: [],
              };
            }
          }
        })
        .filter((el) => el !== undefined);
      setDefaultFieldsOptions(filtered);
    }
  }, []);

  const handleOnClick = () => {
    // if (!filterDataFetched) {
    //   return message.error("Please filter the data before Batch Update");
    // }

    let obj = {};
    obj["document_template_id"] = selectedTemplate.id;
    // obj["filter"] = true;

    let template_field = [];

    if (custom.length > 0) {
      custom.forEach((el) => {
        if (shouldAllow(el)) {
          const { name, value, option } = el;
          const { field_type } = option;
          let field_value =
            field_type === "date_field"
              ? moment(name).format("DD MMM YYYY")
              : field_type === "select_field"
              ? option?.field_options?.filter((ele) => ele.id === name)[0].name
              : name;

          template_field.push({
            value: field_value,
            id: value,
          });
        }
      });
    }

    let revisions = [];

    if (rev.length > 0) {
      rev.forEach((el) => {
        if (shouldAllow(el)) {
          const { name, value } = el;
          revisions.push({ [value]: name });
        }
      });
    }

    let distributions = [];

    if (dist.length > 0) {
      dist.forEach((el) => {
        if (shouldAllow(el)) {
          const { name, value } = el;
          distributions.push({ [value]: name });
        }
      });
    }

    let defaultField = [];

    if (defaults.length > 0) {
      defaults.forEach((el) => {
        const { name, value } = el;
        if (shouldAllow(el)) {
          const { option } = el;
          const { field_type, fieldIndex } = option;
          let field_value =
            field_type === "date_field"
              ? moment(name).format("DD MMM YYYY")
              : field_type === "select_field"
              ? option?.field_options?.filter((ele) => ele.id === name)[0].name
              : name;

          defaultField.push({
            value: field_value,
            id: fieldIndex, // value
          });
        }
      });
    }

    if (template_field.length > 0) {
      obj["template_field"] = template_field;
    }

    if (revisions.length > 0) {
      obj["revisions"] = revisions;
    }

    if (distributions.length > 0) {
      obj["distributions"] = distributions;
    }

    if (defaultField.length > 0) {
      obj["defaultField"] = defaultField;
    }

    handleFilter(obj);
  };

  const handleSelectTemplate = () => {
    setCustom([]);
    setRev([]);
    setDist([]);
  };

  const canUpdate =
    filterDataFetched && selectedTemplate?.id > 0 ? true : false;

  return (
    <Col span={24} className="ims-doc-filter-section">
      <Row align="middle" justify="space-between" className="filter-header">
        <Col className="filter-col">
          <div className="batch-icon-div">
            <div className="patch-icon">
              <BatchUpdateIcon />
            </div>
            <div>BATCH UPDATE</div>
          </div>

          {/* <FilterIcon /> FILTER */}
        </Col>
        <Col>
          <CrossIcon className="cross-icon" onClick={handleClose} />
        </Col>
      </Row>
      <Row gutter={[40, 20]} className="sections-row">
        <Col className={`sub-sections-col${isCollapsed ? "-collapsed" : ""}`}>
          <div className="label-div">
            <span>DOCUMENT TYPE CUSTOM FIELDS BATCH UPDATE</span>
          </div>
          <DefaultFieldsComponent
            inputFields={defaults}
            setInputFields={setDefault}
            createField={createDefault}
            deleteField={deleteDefault}
            updateField={updateDefault}
            canUpdate={canUpdate}
            selectedTemplate={selectedTemplate}
            setSelectedTemplate={setSelectedTemplate}
            handleSelectTemplate={handleSelectTemplate}
            dynamicFieldsOptions={defaultFieldsOptions}
            setDynamicFieldsOptions={setDefaultFieldsOptions}
          />
          <CustomFieldsComponent
            inputFields={custom}
            setInputFields={setCustom}
            createField={createCustom}
            deleteField={deleteCustom}
            updateField={updateCustom}
            canUpdate={canUpdate}
            selectedTemplate={selectedTemplate}
            setSelectedTemplate={setSelectedTemplate}
            handleSelectTemplate={handleSelectTemplate}
            dynamicFieldsOptions={dynamicFieldsOptions}
            setDynamicFieldsOptions={setDynamicFieldsOptions}
          />
        </Col>
        <Col className={`sub-sections-col${isCollapsed ? "-collapsed" : ""}`}>
          <div className="label-div">
            <span>DOCUMENT TYPE REVISION BATCH UPDATE</span>
          </div>
          <RevisionsFieldsComponent
            inputFields={rev}
            setInputFields={setRev}
            createField={createRev}
            deleteField={deleteRev}
            updateField={updateRev}
            canUpdate={canUpdate}
            selectedTemplate={selectedTemplate}
          />
        </Col>
        <Col className={`sub-sections-col${isCollapsed ? "-collapsed" : ""}`}>
          <div className="label-div">
            <span>DOCUMENT TYPE DISTRIBUTION BATCH UPDATE</span>
          </div>
          <DistributionFieldsComponent
            inputFields={dist}
            setInputFields={setDist}
            createField={createDist}
            deleteField={deleteDist}
            updateField={updateDist}
            canUpdate={canUpdate}
            selectedTemplate={selectedTemplate}
          />
        </Col>
        <Col
          className={`sub-sections-filter-col${
            isCollapsed ? "-collapsed" : ""
          }`}
        >
          <div className="batch-update-div">
            <div onClick={handleOnClick}>
              Apply <br /> BATCH UPDATE
            </div>
          </div>
        </Col>
      </Row>
    </Col>
  );
};

export default BatchUpdateSection;
